import type { FileConfig } from '../types/FileConfig';

/**
 * Configuration for Erdos Miller HASS logger CSV files
 */
export const HASS_CONFIGS: Record<string, FileConfig> = {
  HASS_DEFAULT: {
    // Prefer 'timestamp' (YYYY:MM:DD HH:MM:SS) so earliest rows parse across all fixtures
    timeColumns: ['timestamp', 'tool_timestamp'],
    // A few distinctive columns to help header detection when needed
    expectedColumns: [
      'calculated_azimuth',
      'calculated_inclination',
      'calculated_gravity_toolface',
      'calculated_magnetic_toolface',
      'gamma',
      'flow_on'
    ],
    toolType: 'HASS',
    fileType: 'HASS_Logger',
    dataType: 'timeseries',
    // Keep local parsing; timestamps appear as "YYYY-MM-DD HH:MM:SS"
    timestampConfig: { timezone: 'none' },
    // Use default column name cleaning
    autoClean: true
  }
};
